import { FormBlockerElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'

import { decorators } from './decorators'

export interface DecoratorProps {
  children: React.ReactElement
  elements: FormBlockerElement[]
  index: number
}

export type DecoratorFn = (props: DecoratorProps) => React.ReactElement | null

export const getElementType = (element: FormBlockerElement) => {
  // id and background_style are sibling scalars on the element wrapper, not element payloads.
  return Object.keys(element ?? {}).find(key => key !== 'id' && key !== 'background_style') as keyof FormBlockerElement
}

export const FormBlockerElementDecorator = ({ children, elements, index }: DecoratorProps) => {
  for (const decorator of decorators) {
    const result = decorator({ children, elements, index })
    if (result != null) {
      children = result
    }
  }
  return children
}
